import { i18n } from '@/plugins/i18n'

export default [
    {
        field: 'id',
        title: '#',
        textAlign: 'center',
        width: 80,
        template: (row) => {
            return `<p>${row.id}</p>`
        },
    },
    {
        field: 'terminal_number',
        title: 'شماره ترمینال',
        textAlign: 'center',
        width: 80,
        template: (row) => {
            return `<p>${row.terminal_number}</p>`
        },
    },
    {
        field: 'period',
        title: 'دوره',
        textAlign: 'center',
        width: 80,
        template: (row) => {
            return `<p>${row.period}</p>`
        },
    },
    {
        field: 'transaction_count',
        title: 'تعداد تراکنش',
        textAlign: 'center',
        width: 80,
        template: (row) => {
            return `<p>${row.transaction_count}</p>`
        },
    },
    {
        field: 'total_amount',
        title: 'گردش کل (ریال)',
        textAlign: 'center',
        width: 80,
        template: (row) => {
            return `<p>${row.total_amount}</p>`
        },
    },
]